import React from "react";
import { Box } from "@mui/material";
import { logoSx } from "../assets/theme";

export const MainLogo = () => {
  return <Box sx={logoSx.main}>ꜵ</Box>;
};
